{
  "info": "Informacija",
  "negative": "Klaida",
  "notice": "Įspėjimas",
  "positive": "Sėkmingai"
}
